import { render, staticRenderFns } from "./tentangkami.vue?vue&type=template&id=1438e25a"
import script from "./tentangkami.vue?vue&type=script&lang=js"
export * from "./tentangkami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports